export default "__VITE_ASSET__9082fc2d__"